
import {  mapState, mapActions } from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'

export default {
data() {
return {
}
},
components: {
Loading
},
methods: {



},
computed: {
isIndex() {
return /index/.test(this.$route.path)
},
isMy() {
return /my/.test(this.$route.path)
},
isInteraction() {
return /interaction/.test(this.$route.path)
},
isCheck() {
return /check/.test(this.$route.path)
},
...mapState({
route: state => state.route,
path: state => state.route.path,
deviceready: state => state.app.deviceready,
demoTop: state => state.vux.demoScrollTop,
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction,
isTabbaerShow: state => state.vux.isTabbaerShow
}),
},
created() {
},
}



// WEBPACK FOOTER //
// ./src/App.vue